export default "__VITE_ASSET__BRxz92Xu__"